import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RefCapture from "@/components/RefCapture";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import TestDetail from "@/pages/TestDetail";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import RepProfile from "@/pages/RepProfile";
import CalculatorPublic from "@/pages/CalculatorPublic";
import ProviderHub from "@/pages/ProviderHub";
import PhysicianOnboarding from "@/pages/PhysicianOnboarding";
import Activate from "@/pages/Activate";
import PaymentSuccess from "@/pages/PaymentSuccess";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import Physicians from "@/pages/dashboard/Physicians";
import Team from "@/pages/dashboard/Team";
import Earnings from "@/pages/dashboard/Earnings";
import Share from "@/pages/dashboard/Share";
import Compensation from "@/pages/dashboard/Compensation";
import Training from "@/pages/dashboard/Training";
import Settings from "@/pages/dashboard/Settings";
import AdminPanel from "@/pages/dashboard/AdminPanel";
import Payouts from "@/pages/dashboard/Payouts";
import Leads from "@/pages/dashboard/Leads";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RefCapture />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/tests/:slug" element={<TestDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/r/:code" element={<RepProfile />} />
            <Route path="/calculator" element={<CalculatorPublic />} />
            <Route path="/provider-hub" element={<ProviderHub />} />
            <Route path="/physician-onboarding" element={<PhysicianOnboarding />} />
            <Route
              path="/activate"
              element={
                <ProtectedRoute>
                  <Activate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment/success"
              element={
                <ProtectedRoute>
                  <PaymentSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="physicians" element={<Physicians />} />
              <Route path="team" element={<Team />} />
              <Route path="earnings" element={<Earnings />} />              <Route path="compensation" element={<Compensation />} />
              <Route path="share" element={<Share />} />
              <Route path="leads" element={<Leads />} />
              <Route path="training" element={<Training />} />
              <Route path="settings" element={<Settings />} />
              <Route path="admin" element={<AdminPanel />} />
              <Route path="payouts" element={<Payouts />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
